import $ from "jquery";

(() => {
    const account = {
        init: function () {
            $('body').on('click', '.js-input-set', this.inputSet);

            $('body').on('submit-success', '#addLocationModal form', function(){
                $('#addLocationModal').modal('hide');
                window.location.reload();
            });
        },

        inputSet: function (e) {
            e.preventDefault();
            const $this = $(this);

            $($this.data('target')).val($this.data('value'));
        }
    }.init();
})();



// WEBPACK FOOTER //
// ./resources/assets/js/modules/account.js